var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex",attrs:{"id":"FooterComponent"}},[_c('div',{staticClass:"d-flex container align-content-center align-items-center h-100 w-100"},[_c('div',{staticClass:"d-flex justify-content-around w-100"},[_c('ContactMe'),_c('GitHubProfile')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }